import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function ValidationInvalid(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "#FFEDF1",
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z"
  }), React.createElement("path", {
    stroke: "#E91640",
    d: "M12 7v5"
  }), React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1,
    fill: "#E91640"
  }));
}

export { ValidationInvalid };
//# sourceMappingURL=ValidationInvalid.js.map